/* global lazyframe */
'use strict'
const lazyload = {
	el: {
		iframes: document.querySelectorAll('.js-lazyframe')
	},

	fxLazyFrame (el) {
		lazyframe(el)
	},

	init () {
		if(this.el.iframes.length > 0) {
			for(const iframe of this.el.iframes) {
				this.fxLazyFrame(iframe)
			}
		}	
	}
}

lazyload.init()